import Breadcrumb from "component/common/breadcrumb";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import strings from "translate/language";
import { bookingStatus } from "utils/constants";
import { handleDetailResponse, seo } from "utils/utils";
import { getBookingDetails } from "../../reduxStore/action/bookingActions";

const ViewBooking = () => {
  const dispatch = useDispatch();
  const [bookingDetails, setBookingDetails] = useState({});
  const params = useParams();
  const { booking_id = "" } = params || {};

  const BookingDetailSelector = useSelector((state) => state.booking);

  useEffect(() => {
    dispatch(getBookingDetails({ booking_id }));
  }, []);

  useEffect(() => {
    if (BookingDetailSelector.response) {
      const { response } = BookingDetailSelector;
      if (response?.status === 200) {
        setBookingDetails(handleDetailResponse(response?.data));
      } else {
        setBookingDetails({});
      }
    }
  }, [BookingDetailSelector]);

  useEffect(() => {
    seo({
      title: "Booking Details",
      metaDescription: "Booking details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.booking}
        url={"/booking_list"}
        parentListing={strings.bookingListing}
        titleactive={strings.viewBooking}
        isBackBtn={true}
      />

      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.viewBooking}</h5>
              </div>
              <div className="card-body pt-0">
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      <h6>{strings.visitScore} : </h6>
                    </label>
                  </div>
                  <div className="col-md-7 ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      <h6>{bookingDetails?.leads?.lead_score || 0}</h6>
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.configuration} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails.configuration || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.Area} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails.area || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.budget} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {/* {bookingDetails?.leads?.budget?.min_budget &&
                      bookingDetails?.leads?.budget?.max_budget
                        ? `${bookingDetails?.leads?.budget?.min_budget}${bookingDetails?.leads?.budget?.min_budget_type} - ${bookingDetails?.leads?.budget?.max_budget}${bookingDetails?.leads?.budget?.max_budget_type}`
                        : strings.notavailable} */}
                      {bookingDetails?.budget_amount
                        ? bookingDetails?.budget_amount
                        : bookingDetails?.min_budget &&
                          bookingDetails?.max_budget
                        ? `${bookingDetails?.min_budget}${bookingDetails?.min_budget_type} - ${bookingDetails?.max_budget}${bookingDetails?.max_budget_type}`
                        : strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center ">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.currentStatus} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingStatus[bookingDetails?.booking_status] ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row pt-0">
                  <div className="col-md-3 align-items-center ">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.propertyName} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails.properties?.property_title ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.bookingAmount} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails?.booking_amount || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.bookingNumber} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails?.booking_no || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.bookingBy} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails?.booking_by_name || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.chequeNumber} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails?.tranjection_upi_cheque_number ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.PaymentType} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails?.payment_type || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row pt-0">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.confiQty} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {bookingDetails?.configuration && bookingDetails?.quantity
                        ? `${bookingDetails?.configuration} / ${bookingDetails?.quantity}`
                        : "NA"}
                    </label>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewBooking;
